import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/bottomBar.css';
// constants & helpers
import {CHIPS, getHumanReadableChipValue} from '../../../../constants/chips';
import {ASSETS_URL} from '../../../../constants/endpoints';
import {OPERATOR} from '../../../../constants/operator';
import {getFormattedCurrency, getText} from '../../../../helpers/localization';
import {isLocalStorageAvailable} from '../../../../helpers/systemHelpers';
// actions
import {selectChip} from '../../../../actions/raceCardActions';
import {removeAllBets, undoLastBetAction} from '../../actions/openBetsActions';
import {openCloseBetBetHistory} from '../../actions/betHistoryActions';
import {openCloseHelpPages} from '../../../../actions/helpPagesActions';
import {openCloseSettings} from '../../../../actions/settingsActions';
import {fakePlaceBets, placeAndClearOpenBets} from '../../helpers/betHelpers';
import {clearEventOpenBets} from '../../../../actions/eventsActions';

const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedChip: state.vpp.selectedChip,
        openBetsHistory: state.vpp.openBetsHistory,
        openBetsList: state.vpp.openBetsList,
        settledBets: state.vpp.settledBets,
        selectedEventIndex: state.vpp.selectedEventIndex
    }
};

class BottomBar extends Component {
    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            selectedChip: storeData.vpp.selectedChip,
            openBetsHistory: storeData.vpp.openBetsHistory,
            openBetsList: storeData.vpp.openBetsList,
            settledBets: storeData.vpp.settledBets,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            flashBetHistoryButton: false
        };
    }

    componentWillReceiveProps(nextProps) {
        let existsUnreadSettledBets = false;
        if (isLocalStorageAvailable) {
            let unreadLocalBets = sessionStorage.getItem('UNREAD_BETS');
            if (unreadLocalBets !== undefined && unreadLocalBets !== null) {
                unreadLocalBets = JSON.parse(unreadLocalBets);
                existsUnreadSettledBets = !unreadLocalBets.playerWasNotified && unreadLocalBets.settledBets !== undefined && unreadLocalBets.settledBets.length > 0;

                if (existsUnreadSettledBets) {
                    setTimeout(() => this.setState({
                        ...this.state,
                        flashBetHistoryButton: false
                    }), 10000);

                    unreadLocalBets.playerWasNotified = true;
                    sessionStorage.setItem('UNREAD_BETS', JSON.stringify(unreadLocalBets));
                }
            }
        }

        let store = nextProps.store;
        let storeData = store.getState();

        this.setState({
            games: storeData.vpp.games,
            selectedChip: storeData.vpp.selectedChip,
            openBetsHistory: storeData.vpp.openBetsHistory,
            openBetsList: storeData.vpp.openBetsList,
            settledBets: storeData.vpp.settledBets,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            flashBetHistoryButton: existsUnreadSettledBets
                ? true
                : this.state.flashBetHistoryButton
        });
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();

        let eventId = storeData.vpp.events.length
            ? storeData.vpp.events[storeData.vpp.selectedEventIndex].eventId
            : 0;
        let gameChannel = storeData.vpp.games[storeData.vpp.selectedGameIndex].channel;

        let chipsListUI = CHIPS.map(
            (chip, index) => <div
                id={'chip_' + index}
                key={'chip_' + index}
                className={style.chipIconContainer}
                onClick={() => this.props.store.dispatch(selectChip(index))}>
                <div className={style.chipValueOuter}>
                    <div
                        className={`${style.chipValueInner} ${index === this.state.selectedChip
                            ? style.selected
                            : ''}`}>{getFormattedCurrency(this.props.store, getHumanReadableChipValue(index).toString(), 0)}</div>
                </div>
                <img
                    className={`${style.chipIcon} ${index === this.state.selectedChip
                        ? style.selected
                        : ''}`}
                    src={`${ASSETS_URL + CHIPS[index].assetChip}`}
                    alt={'chips'}/>
            </div>
        );
        return (
            <div className={style.bottomBarContainer}>
                <div className={style.chipsPanel}>
                    {chipsListUI}
                </div>
                <div className={style.buttonsPanel}>
                    <div className={style.bottomButtonContainer}>
                        <div
                            id={'betHistory'}
                            className={`${style.bottomBaseButton} ${this.state.flashBetHistoryButton
                                ? style.flashingButton
                                : ''}`}
                            onClick={() => this.props.store.dispatch(openCloseBetBetHistory())}>
                            <img className={style.historyclockIcon} src={`${ASSETS_URL}systemIcons/historyclock.svg`}
                                 alt={'history'}/>
                            <div
                                className={style.bottomBaseButtonBottomLine}>{getText('HISTORY', this.props.store).toUpperCase()}</div>
                        </div>
                    </div>
                    <div id={'help'} className={style.bottomButtonContainer}
                         onClick={() => this.props.store.dispatch(openCloseHelpPages())}>
                        <div className={style.bottomBaseButton}>
                            <img className={style.infoIcon} src={`${ASSETS_URL}systemIcons/info.svg`} alt={'help'}/>
                        </div>
                    </div>
                    <div id={'settings'} className={style.bottomButtonContainer}
                         onClick={() => this.props.store.dispatch(openCloseSettings())}>
                        <div className={style.bottomBaseButton}>
                            <img className={style.settingsIcon} src={`${ASSETS_URL}systemIcons/cog.svg`} alt={'help'}/>
                        </div>
                    </div>
                    <div id={'undoAll'} className={style.bottomButtonContainer}
                         onClick={() => this.props.store.dispatch(removeAllBets())}>
                        <div className={style.bottomBaseButton}>
                            <img className={style.undoAllIcon} src={`${ASSETS_URL}systemIcons/undoall.svg`}
                                 alt={'help'}/>
                            <div
                                className={style.bottomBaseButtonBottomLine}>{getText('CLEAR', this.props.store).toUpperCase()}</div>
                        </div>
                    </div>
                    <div
                        id={'undo'}
                        className={style.bottomButtonContainer}
                        onClick={() => this.props.store.dispatch(undoLastBetAction(this.state.openBetsHistory, this.state.openBetsList, eventId, gameChannel))}>
                        <div className={style.bottomBaseButton}>
                            <img className={style.undoIcon} src={`${ASSETS_URL}systemIcons/undo.svg`} alt={'help'}/>
                            <div
                                className={style.bottomBaseButtonBottomLine}>{getText('UNDO', this.props.store).toUpperCase()}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    _placeBets(store, dispatch) {
        if (OPERATOR.clientType === 'Simplified') {
            if (process.env.NODE_ENV !== 'development') {
                placeAndClearOpenBets(
                    store.vpp.games[store.vpp.selectedGameIndex].channel,
                    store.vpp.selectedEventId,
                    undefined,
                    store,
                    dispatch
                );
            } else {
                fakePlaceBets(store.vpp.games[store.vpp.selectedGameIndex].channel, dispatch);
                dispatch(clearEventOpenBets(store.vpp.games[store.vpp.selectedGameIndex].channel, store.vpp.selectedEventId));
            }
        }
    }
}

export default connect(mapStateToProps)(BottomBar);



// WEBPACK FOOTER //
// ./src/ui-modules/simplified/desktop/containers/bottomBar.js